var CandidateConferencePageController = /** @class */ (function () {
    /*@ngInject*/
    function CandidateConferencePageController($timeout) {
        this.$timeout = $timeout;
    }
    CandidateConferencePageController.prototype.$onInit = function () {
        var _this = this;
        this.$stateParams = this.$transition$.params();
        this.candidateId = this.$stateParams.c;
        this.jobId = this.$stateParams.j;
        this.jobMatchId = this.$stateParams.jm;
        this.scheduleId = this.$stateParams.sh;
        // this.participantType = this.$stateParams.t;
        this.participantType = "c";
        this.mode = this.$stateParams.mode;
        this.workflowStep = this.$stateParams.ws;
        this.$timeout(function () {
            _this.isLoaded = true;
        }, 4000);
    };
    return CandidateConferencePageController;
}());
export { CandidateConferencePageController };
CandidateConferencePageController.$inject = ['$timeout'];
// import * as TEMPLATE from './candidate-conference-page.html';
import * as TEMPLATE from 'raw-loader!./candidate-conference-page.html';
export var CandidateConferencePageComponent = {
    selector: 'candidateConferencePage',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/candidateConference/candidate-conference-page.html',
        template: TEMPLATE.default,
        controller: CandidateConferencePageController
    }
};
//# sourceMappingURL=candidate-conference-page.component.js.map